export default {
  // Timers
  currentTimestamp: null,
  fetchedTimestamp: null,
  intervalId: null, // Just to clear on clean up.

  // Data
  group: {},
  maxLevel: 0,
  expandedIds: []
}
